<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="giga-header">
    <!-- BREADCRUMBS -->
    <div class="giga-breadcrumbs">
      <ul class="breadcrumbs-row" v-if="!this.isTeamAgenceRoute">
        <!--        <li class="breadcrumb-item"><span>Tableau de bord</span></li>-->
        <template v-for="(route, index) in lastThreeRoutes">
          <!--          <template v-if="route.path">-->
          <li
            class="breadcrumb-item breadcrumb-arrow"
            v-if="index !== 0"
            :key="'arrow' + index"
          >
            <img src="../../assets/images/breadcrumb-arrow-icon.svg" />
          </li>
          <router-link
            :to="{ name: route.name }"
            class="breadcrumb-item"
            style="white-space: nowrap;"
            :class="{ currentPage: $route.name === route.name }"
            :key="index"
          >
            <span
              v-if="
                route.name === 'Dashboard' &&
                  getCurrentUser.clientType === USER_TYPE.B2B2B &&
                  (getCurrentUser.admin ||
                    (getCurrentUser.role &&
                      getCurrentUser.role.roleType === ROLE_TYPE.ADMIN_AGENCE))
              "
              >{{ $t("welcome") }}</span
            >
            <span v-else>{{
              $te("route." + route.name)
                ? $t("route." + route.name)
                : route.name
            }}</span>
          </router-link>
          <!--          </template>-->
        </template>
        <!--        <li-->
        <!--          class="breadcrumb-item"-->
        <!--          v-if="-->
        <!--            getCurrentUser.clientType === this.USER_TYPE.B2B2B &&-->
        <!--              getCurrentUser.role &&-->
        <!--              getCurrentUser.role.roleType === this.ROLE_TYPE.ADMIN_AGENCE &&-->
        <!--              getCurrentUser.agences.length > 1 &&-->
        <!--              $route.name !== 'Reporting'-->
        <!--          "-->
        <!--        >-->
        <!--          <div class="d-flex justify-content-center align-items-center p-3">-->
        <!--            <div class="p-3 me-2  text-center flex-fill">-->
        <!--              <div class="giga-fields ml-1">-->
        <!--                <div class="giga-input_field mb-0">-->
        <!--                  <div-->
        <!--                    class="input-field_area multiselect_wrapper"-->
        <!--                    style="width: 320px"-->
        <!--                  >-->
        <!--                    <multiselect-->
        <!--                      id="switchAgenceHeader"-->
        <!--                      v-select-overflow-->
        <!--                      v-model="currentAgence"-->
        <!--                      :options="getCurrentUser.agences"-->
        <!--                      label="raisonSocial"-->
        <!--                      open-direction="bottom"-->
        <!--                      :searchable="true"-->
        <!--                      :multiple="false"-->
        <!--                      class="tags-outline"-->
        <!--                      :close-on-select="true"-->
        <!--                      :allow-empty="false"-->
        <!--                    >-->
        <!--                      <template slot="singleLabel" slot-scope="{ option }">-->
        <!--                        {{ option.raisonSocial }}-->
        <!--                      </template>-->
        <!--                      <template slot="option" slot-scope="{ option }">-->
        <!--                        {{ option.raisonSocial }}-->
        <!--                      </template>-->
        <!--                      <template slot="caret">-->
        <!--                        <div-->
        <!--                          class="multiselect__select d-flex align-items-center justify-content-center"-->
        <!--                        >-->
        <!--                          <div>-->
        <!--                            <b-icon icon="chevron-down"></b-icon>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </template>-->
        <!--                    </multiselect>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="p-3 text-white text-center flex-fill giga-button">-->
        <!--              <button-->
        <!--                class="giga-green_button p-2"-->
        <!--                style="height: 30px"-->
        <!--                @click="onAgenceChange"-->
        <!--              >-->
        <!--                valider-->
        <!--              </button>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </li>-->
      </ul>
      <ul class="breadcrumbs-row" v-if="this.isTeamAgenceRoute">
        <!--        <li class="breadcrumb-item"><span>Tableau de bord</span></li>-->
        <template>
          <router-link :to="{ name: 'Agences' }" class="breadcrumb-item">
            <span>Agences</span>
          </router-link>
          <li class="breadcrumb-item breadcrumb-arrow">
            <img src="../../assets/images/breadcrumb-arrow-icon.svg" />
          </li>
          <router-link
            :to="{ name: this.$route.name }"
            class="breadcrumb-item currentPage"
            style="white-space: nowrap;"
          >
            <span>{{ this.agence.raisonSocial }}</span>
          </router-link>
          <!--          </template>-->
        </template>
        <!--        <li-->
        <!--          class="breadcrumb-item"-->
        <!--          v-if="-->
        <!--            getCurrentUser.clientType === this.USER_TYPE.B2B2B &&-->
        <!--              getCurrentUser.role &&-->
        <!--              getCurrentUser.role.roleType === this.ROLE_TYPE.ADMIN_AGENCE &&-->
        <!--              getCurrentUser.agences.length > 1-->
        <!--          "-->
        <!--        >-->
        <!--          <div class="d-flex justify-content-center align-items-center p-3">-->
        <!--            <div class="p-3 me-2  text-center flex-fill">-->
        <!--              <div class="giga-fields ml-1">-->
        <!--                <div class="giga-input_field mb-0">-->
        <!--                  <div-->
        <!--                    class="input-field_area multiselect_wrapper"-->
        <!--                    style="width: 320px"-->
        <!--                  >-->
        <!--                    <multiselect-->
        <!--                      id="switchAgenceHeader"-->
        <!--                      v-select-overflow-->
        <!--                      v-model="currentAgence"-->
        <!--                      :options="getCurrentUser.agences"-->
        <!--                      label="raisonSocial"-->
        <!--                      open-direction="bottom"-->
        <!--                      :searchable="true"-->
        <!--                      :multiple="false"-->
        <!--                      class="tags-outline"-->
        <!--                      :close-on-select="true"-->
        <!--                      :allow-empty="false"-->
        <!--                    >-->
        <!--                      <template slot="singleLabel" slot-scope="{ option }">-->
        <!--                        {{ option.raisonSocial }}-->
        <!--                      </template>-->
        <!--                      <template slot="option" slot-scope="{ option }">-->
        <!--                        {{ option.raisonSocial }}-->
        <!--                      </template>-->
        <!--                      <template slot="caret">-->
        <!--                        <div-->
        <!--                          class="multiselect__select d-flex align-items-center justify-content-center"-->
        <!--                        >-->
        <!--                          <div>-->
        <!--                            <b-icon icon="chevron-down"></b-icon>-->
        <!--                          </div>-->
        <!--                        </div>-->
        <!--                      </template>-->
        <!--                    </multiselect>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--            <div class="p-3 text-white text-center flex-fill giga-button">-->
        <!--              <button-->
        <!--                class="giga-green_button p-2"-->
        <!--                style="height: 30px"-->
        <!--                @click="onAgenceChange"-->
        <!--              >-->
        <!--                valider-->
        <!--              </button>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </li>-->
      </ul>
    </div>

    <!-- USER LOGGEDIN -->
    <div class="giga-userLoggedIn">
      <ul class="userLoggedIn-row">
        <!-- SETTINGS -->
        <li class="userLoggedIn-option">
          <b-link :to="{ name: 'Profile' }" class="userLoggedIn-action">
            <svg
              width="27"
              height="29"
              viewBox="0 0 27 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M24.8542 17.2667L23.461 16.4541C21.9517 15.5253 21.9517 13.3194 23.461 12.3906L24.8542 11.5779C26.0151 10.8813 26.3634 9.48816 25.6668 8.44327L24.5059 6.4696C23.8093 5.30862 22.4161 4.96032 21.3712 5.65691L19.978 6.4696C18.4688 7.39839 16.4951 6.2374 16.4951 4.49593V2.87055C16.4951 1.59347 15.4502 0.548584 14.1731 0.548584H11.8511C10.5741 0.548584 9.52918 1.59347 9.52918 2.87055V4.37983C9.52918 6.1213 7.55551 7.28229 6.04623 6.3535L4.65305 5.65691C3.49207 4.96032 2.09889 5.42471 1.51839 6.4696L0.357411 8.44327C-0.22308 9.60425 0.125215 10.9974 1.1701 11.694L2.56328 12.5067C4.07256 13.3194 4.07256 15.6414 2.56328 16.4541L1.1701 17.2667C0.00911641 17.9633 -0.339179 19.3565 0.357411 20.4014L1.51839 22.3751C2.21498 23.5361 3.60817 23.8844 4.65305 23.1878L6.04623 22.4912C7.55551 21.5624 9.52918 22.7234 9.52918 24.4648V26.0902C9.52918 27.3673 10.5741 28.4122 11.8511 28.4122H14.1731C15.4502 28.4122 16.4951 27.3673 16.4951 26.0902V24.5809C16.4951 22.8395 18.4688 21.6785 19.978 22.6073L21.3712 23.42C22.5322 24.1165 23.9254 23.6522 24.5059 22.6073L25.6668 20.6336C26.2473 19.3565 25.899 17.9633 24.8542 17.2667ZM13.0121 19.1243C10.458 19.1243 8.3682 17.0345 8.3682 14.4804C8.3682 11.9262 10.458 9.83645 13.0121 9.83645C15.5663 9.83645 17.6561 11.9262 17.6561 14.4804C17.6561 17.0345 15.5663 19.1243 13.0121 19.1243Z"
                fill="#132D48"
              />
            </svg>
          </b-link>
        </li>
        <!-- NOTIFICATIONS -->
        <li class="userLoggedIn-option" :class="{ toggleNotifs: toggleNotifs }">
          <button
            class="userLoggedIn-action"
            v-click-outside="closeNotifDropdown"
            @click="toggleNotifsDropdown()"
          >
            <span class="giga-noticeDot"></span>
            <svg
              width="22"
              height="28"
              viewBox="0 0 22 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.9707 27.4121C12.4758 27.4121 13.7073 26.1583 13.7073 24.6258H8.23411C8.23411 26.1583 9.45189 27.4121 10.9707 27.4121ZM19.1805 19.053V12.0871C19.1805 7.81008 16.9365 4.22961 13.0232 3.28225V2.33489C13.0232 1.17855 12.1064 0.245117 10.9707 0.245117C9.83502 0.245117 8.91826 1.17855 8.91826 2.33489V3.28225C4.99123 4.22961 2.7609 7.79615 2.7609 12.0871V19.053L0.995789 20.8503C0.133759 21.728 0.735811 23.2326 1.9536 23.2326H19.9741C21.1919 23.2326 21.8077 21.728 20.9456 20.8503L19.1805 19.053Z"
                fill="#132D48"
              />
            </svg>
          </button>
          <div class="giga-notifications-dropdown">
            <div class="giga-notifications_wrap">
              <div class="giga-notifications_header">
                <h3>Notifications</h3>
                <b-link :to="{ name: 'Notifications' }">Voir tout</b-link>
              </div>
              <div class="giga-notifications_body">
                <div>
                  <b-tabs>
                    <b-tab v-if="importantNotifications">
                      <!-- MAX 3 NOTIFCATIONS PER ROW -->
                      <template #title>
                        Importantes
                        <span class="giga-notifications_count">{{
                          importantNotifications.length
                        }}</span>
                      </template>
                      <!-- MAX 3 NOTIFCATIONS -->
                      <div
                        class="giga-notifications_list"
                        :id="importantNotifs"
                      >
                        <template
                          v-for="notification in lastImportantNotifications"
                        >
                          <div
                            class="giga-notification_item"
                            :key="notification.id"
                            @click="redirect(notification)"
                          >
                            <div class="giga-notification_icon">
                              <img
                                src="../../assets/images/comment-icon.svg"
                                alt=""
                              />
                            </div>
                            <div class="giga-notification_content">
                              <h3 class="giga-notification_title">
                                <span
                                  class="content-static"
                                  v-html="notification.content"
                                >
                                </span>
                              </h3>
                              <span class="giga-notification_time">
                                {{
                                  moment(notification.creationDate, "x").format(
                                    "DD/MM/YYYY - HH:mm"
                                  )
                                }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </div>
                    </b-tab>
                    <b-tab v-if="notifications">
                      <template #title> Toutes les notifications</template>
                      <!-- MAX 3 NOTIFCATIONS PER ROW -->
                      <template #title>
                        Toutes
                        <span class="giga-notifications_count">{{
                          notifications.length
                        }}</span>
                      </template>
                      <!-- MAX 3 NOTIFCATIONS -->
                      <div
                        class="giga-notifications_list"
                        id="all-notifications"
                      >
                        <template v-for="notification in lastNotifications">
                          <div
                            class="giga-notification_item"
                            :key="notification.id"
                            @click="redirect(notification)"
                          >
                            <div class="giga-notification_icon">
                              <img
                                src="../../assets/images/comment-icon.svg"
                                alt=""
                              />
                            </div>
                            <div class="giga-notification_content">
                              <h3 class="giga-notification_title">
                                <span
                                  class="content-static"
                                  v-html="notification.content"
                                >
                                </span>
                              </h3>
                              <span class="giga-notification_time">
                                {{
                                  moment(notification.creationDate, "x").format(
                                    "DD/MM/YYYY - HH:mm"
                                  )
                                }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>
          </div>
        </li>
        <!-- USER -->
        <li
          class="userLoggedIn-option"
          :class="{ toggledDropdown: toggleDropdown }"
        >
          <button
            class="userLoggedIn-profile"
            v-click-outside="closeDropdown"
            @click="toggleDropdownMenu()"
          >
            <span class="profile-thumb">
              <img
                v-if="getCurrentUser.avatar"
                :src="getCurrentUser.avatar"
                alt="avatar"
              />
              <img v-else src="@/assets/images/contact-mask.svg" alt="avatar" />
            </span>
            <span class="profile-name">
              {{ this.profileName }}
            </span>
            <i class="icon-arrow-bottom">
              <svg
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.70711 0.292893C1.31658 -0.0976311 0.683418 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L1.70711 0.292893ZM7 7L6.29289 7.70711C6.48043 7.89464 6.73478 8 7 8C7.26522 8 7.51957 7.89464 7.70711 7.70711L7 7ZM13.7071 1.70711C14.0976 1.31658 14.0976 0.683417 13.7071 0.292893C13.3166 -0.0976311 12.6834 -0.0976311 12.2929 0.292893L13.7071 1.70711ZM0.292893 1.70711L6.29289 7.70711L7.70711 6.29289L1.70711 0.292893L0.292893 1.70711ZM7.70711 7.70711L13.7071 1.70711L12.2929 0.292893L6.29289 6.29289L7.70711 7.70711Z"
                  fill="#132D48"
                />
              </svg>
            </i>
          </button>
          <div class="giga-dropdown">
            <ul class="giga-dropdown_wrap">
              <li class="dropdown-item">
                <b-link @click="logoutAction()">
                  <i class="icon-logout">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.80222 6.6L8.09111 4.88889L2.15111 10.8289C2.05333 10.9267 2.05333 11.0733 2.15111 11.1711L8.09111 17.1111L9.80222 15.4L6.62444 12.2222H15.6322C15.7667 12.2222 15.8767 12.1122 15.8767 11.9778V10.0222C15.8767 9.88778 15.7667 9.77778 15.6322 9.77778H6.62444L9.80222 6.6ZM19.5556 0H2.44444C1.1 0 0 1.1 0 2.44444V7.08889C0 7.22333 0.11 7.33333 0.244444 7.33333H2.2C2.33444 7.33333 2.44444 7.22333 2.44444 7.08889V2.44444H19.5556V19.5556H2.44444V14.9111C2.44444 14.7767 2.33444 14.6667 2.2 14.6667H0.244444C0.11 14.6667 0 14.7767 0 14.9111V19.5556C0 20.9 1.1 22 2.44444 22H19.5556C20.9 22 22 20.9 22 19.5556V2.44444C22 1.1 20.9 0 19.5556 0Z"
                        fill="#132D48"
                      />
                    </svg>
                  </i>
                  <span>Déconnexion</span>
                </b-link>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="toggle-button">
      <button type="button" class="h1" @click="toggleSidebar()">
        <b-icon icon="list"></b-icon>
      </button>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Vue from "vue";
import { notificationService } from "../../views/service/notification.service";
import { constants } from "@/shared/constants";
import { userService } from "@/views/service/user.service";

Vue.directive("click-outside", {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = event => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

export default {
  name: "Header",
  data() {
    return {
      isTeamAgenceRoute: false,
      toggleDropdown: false,
      toggleNotifs: false,
      currentPage: "",
      USER_TYPE: constants.USER_TYPE,
      ROLE_TYPE: constants.ROLE_TYPE,
      importantNotifs: "important-Notifs",
      rolePagedFilter: {
        myPager: {
          page: 1,
          size: 3
        },
        search: ""
      },
      lastThreeRoutes: [],
      currentAgence: {}
    };
  },
  mounted() {
    this.setSidebarShow(true);
  },
  computed: {
    ...mapGetters("account", ["getCurrentUser"]),
    ...mapGetters("agence", { agence: "getAgence" }),
    ...mapGetters("notification", {
      notifications: "getDashboardNotifications",
      importantNotifications: "getDashboardImportantNotifications"
    }),
    lastNotifications() {
      return this.notifications.slice(
        (this.rolePagedFilter.myPager.page - 1) *
          this.rolePagedFilter.myPager.size,
        (this.rolePagedFilter.myPager.page - 1) *
          this.rolePagedFilter.myPager.size +
          this.rolePagedFilter.myPager.size
      );
    },
    lastImportantNotifications() {
      return this.importantNotifications.slice(
        (this.rolePagedFilter.myPager.page - 1) *
          this.rolePagedFilter.myPager.size,
        (this.rolePagedFilter.myPager.page - 1) *
          this.rolePagedFilter.myPager.size +
          this.rolePagedFilter.myPager.size
      );
    },
    profileName() {
      return this.getCurrentUser.firstName && this.getCurrentUser.lastName
        ? this.getCurrentUser.firstName + " " + this.getCurrentUser.lastName
        : this.getCurrentUser.email;
    },
    setCurrentAgence() {
      return this.getCurrentUser?.agence;
    }
  },
  methods: {
    ...mapMutations({
      toggleSidebar: "leftsidebar/toggleSidebar",
      setSidebarShow: "leftsidebar/setSidebarShow"
    }),
    ...mapActions("account", ["logoutAction"]),
    ...mapActions("notification", [
      "getDashboardNotificationsAction",
      "getDashboardImportantNotificationsAction"
    ]),
    toggleDropdownMenu() {
      this.toggleDropdown = !this.toggleDropdown;
    },
    toggleNotifsDropdown() {
      this.toggleNotifs = !this.toggleNotifs;
      if (this.toggleNotifs) {
        this.getDashboardImportantNotificationsAction();
        this.getDashboardNotificationsAction();
      }
    },
    closeDropdown() {
      this.toggleDropdown = false;
    },
    closeNotifDropdown() {
      this.toggleNotifs = false;
    },
    redirect(notification) {
      if (!notification.callToAction) {
        notificationService.markNotificationsAsRead([notification.id], true);
      }
      this.$router.push(notification.link);
    },
    onAgenceChange() {
      const data = {
        id: this.getCurrentUser.id,
        lastName: this.getCurrentUser.lastName,
        clientType: this.getCurrentUser.clientType,
        firstName: this.getCurrentUser.firstName,
        email: this.getCurrentUser.email,
        phoneNumber: this.getCurrentUser.phoneNumber,
        username: this.getCurrentUser.username,
        isEnabled: this.getCurrentUser.isEnabled,
        admin: this.getCurrentUser.isAdmin,
        role: this.getCurrentUser.role,
        agence:
          this.getCurrentUser.clientType === "B2B2B" &&
          this.getCurrentUser.role?.roleType === this.ROLE_TYPE.ADMIN_AGENCE
            ? this.currentAgence
            : null
      };
      userService.modifyUserActiveAgence(data).then(response => {
        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
    }
  },
  watch: {
    "$route.matched": function() {
      this.lastThreeRoutes = this.$route.matched.slice(
        Math.max(0, this.$route.matched.length - 3),
        this.$route.matched.length
      );
      this.isTeamAgenceRoute =
        this.$route.path.includes("agences") &&
        this.$route.path.includes("users");
      if (!this.isTeamAgenceRoute) this.$store.commit("agence/setAgence", {});
    },
    setCurrentAgence(currentAgence) {
      if (currentAgence) {
        this.currentAgence = this.getCurrentUser.agences.find(
          a => a.id === currentAgence.id
        );
      }
    }
  }
};
</script>
<style lang="scss">
#switchAgenceHeader {
  display: flex;
  flex-direction: column;
  order: -1;
  width: 100px;
  height: 55%;
  padding: 8px;
  border: 0px !important;
  border-radius: 5px;
  margin-bottom: 5px;
}

.multiselect_wrapper .multiselect--active {
  position: relative !important;
}

.multiselect_wrapper .multiselect .multiselect__select {
  height: 20px !important;
}

.multiselect_wrapper .multiselect .multiselect__tags {
  height: 30px !important;
}
</style>
